// extracted by mini-css-extract-plugin
export default {"editIcon":"AudienceTable_editIcon__nAnrD","deleteIcon":"AudienceTable_deleteIcon__HdvTf","table":"AudienceTable_table__6m0Wg"};